import 'app/styles/global/global.scss';
import './feedback.scss';
import cn from 'classnames';

const feedbackData = [
  {
    text: `Я обратилась в DoTherapy, потому что искала действительно профессионального психолога, который мог бы мне помочь с моими проблемами. И я не ошиблась! Мой психолог, Елена, оказалась настоящим экспертом в своей области. Ее подход, знания и опыт просто поражают. Обычно такие высококлассные специалисты работают в очень дорогих клиниках, но я смогла получить доступ к таким же услугам по вполне доступной цене. Это просто невероятно! Спасибо команде МИП за то, что вы собрали таких талантливых и заботливых специалистов.`,
    name: `Мария`,
    age: `30 лет`,
    specialization: `журналистка`,
  },
  {
    text: `Я уже давно искал психолога, который бы понимал меня и мог бы помочь с моими проблемами. В DoTherapy я нашел не просто хорошего специалиста, а настоящего мастера своего дела. Мой психолог Дмитрий имеет свой уникальный подход и личный бренд, который отличает его от других. Обычно такие специалисты работают с VIP-клиентами, но я смог получить доступ к его услугам. Это просто мечта! Спасибо DoTherapy за то, что вы сделали такие высококлассные услуги доступными для всех.`,
    name: `Александр`,
    age: `35 лет`,
    specialization: `предприниматель`,
  },
  {
    text: `Мне очень понравился онлайн-формат консультаций на платформе. Это так удобно и комфортно – можно общаться с психологом из любой точки мира. Специалисты очень профессиональные и помогли мне решить мои проблемы. Рекомендую всем!`,
    name: `Иван`,
    age: `32 года`,
    specialization: `фрилансер`,
  },
  {
    text: `Я всегда была очень стеснительной и боялась общаться с новыми людьми, год хожу на групп-анализ. Групповая терапия в DoTherapy стала для меня настоящим спасением – я нашла поддержку и научилась выражать свои чувства. Теперь я чувствую себя намного увереннее и спокойнее, и хочу еще больше изучить себя!`,
    name: `Елена`,
    age: `29 лет`,
    specialization: `дизайнер`,
  },
  {
    text: `Мы столкнулись с проблемами в общении с подростком. Здесь нам помогли наладить отношения и научиться понимать друг друга. Теперь наш дом стал намного гармоничнее. Спасибо за отличную работу и поддержку!`,
    name: `Наталья и Сергей`,
    age: `40 и 42 года`,
    specialization: ``,
  },
  {
    text: `Я приобрела абонемент на 10 сессий в DoTherapy и ни разу не пожалела! Это очень удобно и выгодно. Я могу планировать свои сессии заранее и всегда знаю, что у меня есть поддержка и возможность поговорить с профессионалом. DoTherapy – это отличный сервис именно профессиональных, сильных психологов для тех, кто заботится о своем ментальном здоровье, а не просто просто потому что модно, надо!`,
    name: `Светлана`,
    age: `31 год`,
    specialization: `менеджер`,
  },
  {
    text: `Я долгое время жила с постоянной тревожностью, которая мешала мне нормально работать и общаться с людьми. Решила обратиться в DoTherapy и попала к замечательному психологу Диане. Уже после нескольких сессий я почувствовала, как тревога отступает, и научилась техникам, которые помогают мне справляться со стрессом. Теперь я чувствую себя намного увереннее и счастливее! Огромное спасибо Диане за помощь!`,
    name: `Мария`,
    age: `28 лет`,
    specialization: `маркетолог`,
  },
  {
    text: `Во время кризиса, когда случился очередной ххххх,  я чувствовал себя потерянным и не знал, что делать. Обратился в DoTherapy по совету друзей, и там мне оказали поддержку и помогли найти выход из ситуации. Теперь я чувствую себя намного лучше и благодарен за помощь. Понял, что психология реально работает и поддержка нужна, раньше я был против всего этого. Буду продолжать заниматься. Друзья шутят, что я сейчас “проработанный”.`,
    name: `Дмитрий`,
    age: `38 лет`,
    specialization: `менеджер`,
  },
];

const Feedback = () => (
  <section className="feedback">
    <div className="feedback__container container">
      <div className="feedback__heading">
        <h2 className="feedback__title section-title">
          Люди, которым
          <br /> мы <span>помогли</span>
        </h2>
        <p className="feedback__subtitle">
          Мы стремимся к прозрачности и публикуем все отзывы, даже негативные.
          Отзыв может оставить любой пользователь, который провел хотя бы одну
          консультацию на платформе
        </p>
      </div>
      <div className="feedback__list-wrapper">
        <ul className="feedback__list">
          {feedbackData.map((item, index) => (
            <li
              className={cn('feedback__item', {
                ['feedback__item--w-plus']: (index + 1) % 2 === 0,
                ['feedback__item--w-heart']: (index + 1) % 3 === 1,
              })}
            >
              <p>{item.text}</p>
              <span>{`${item.name}, ${item.age}, ${item.specialization}`}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);

export default Feedback;
